import { useEffect, useState } from "react";
import { AdminLayout } from "@/components/AdminLayout";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

const empty = { name: "", category: "", cidade: "", estado: "", discount: "", description: "", instructions: "", is_active: true };

export default function AdminBeneficios() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);
  const load = () => api.get("/benefits").then(r => setItems(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      if (editId) await api.put(`/admin/benefits/${editId}`, form); else await api.post("/admin/benefits", form);
      toast.success("Salvo");
      setOpen(false); setEditId(null); setForm(empty); load();
    } catch { toast.error("Erro"); }
  };
  const edit = (b) => { setEditId(b.id); setForm({ ...b }); setOpen(true); };
  const remove = async (id) => { if (window.confirm("Excluir?")) { await api.delete(`/admin/benefits/${id}`); load(); } };

  return (
    <AdminLayout title="Convênios">
      <div className="flex justify-end mb-3">
        <Button onClick={() => { setEditId(null); setForm(empty); setOpen(true); }} data-testid="benefit-new"><Plus className="w-4 h-4 mr-1" /> Novo convênio</Button>
      </div>
      <Card className="rounded-xl"><CardContent className="p-0 overflow-x-auto">
        <Table><TableHeader><TableRow>
          <TableHead>Parceiro</TableHead><TableHead>Categoria</TableHead><TableHead>Local</TableHead><TableHead>Desconto</TableHead><TableHead>Status</TableHead><TableHead className="text-right">Ações</TableHead>
        </TableRow></TableHeader>
          <TableBody>
            {items.map(b => (
              <TableRow key={b.id}>
                <TableCell className="font-medium">{b.name}</TableCell>
                <TableCell className="capitalize">{b.category}</TableCell>
                <TableCell>{b.cidade}/{b.estado}</TableCell>
                <TableCell>{b.discount}</TableCell>
                <TableCell>{b.is_active ? "Ativo" : "Inativo"}</TableCell>
                <TableCell className="text-right">
                  <Button variant="ghost" size="icon" onClick={() => edit(b)}><Pencil className="w-4 h-4" /></Button>
                  <Button variant="ghost" size="icon" onClick={() => remove(b.id)}><Trash2 className="w-4 h-4 text-rose-600" /></Button>
                </TableCell>
              </TableRow>
            ))}
            {items.length === 0 && <TableRow><TableCell colSpan={6} className="py-10 text-center text-sm text-muted-foreground">Nenhum convênio cadastrado</TableCell></TableRow>}
          </TableBody>
        </Table>
      </CardContent></Card>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-[520px] rounded-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader><DialogTitle>{editId ? "Editar convênio" : "Novo convênio"}</DialogTitle></DialogHeader>
          <form onSubmit={submit} className="space-y-3">
            <div><Label>Nome</Label><Input required value={form.name} onChange={(e) => setForm(f => ({ ...f, name: e.target.value }))} /></div>
            <div className="grid grid-cols-2 gap-3">
              <div><Label>Categoria</Label><Input value={form.category} onChange={(e) => setForm(f => ({ ...f, category: e.target.value }))} placeholder="hoteis, livrarias..." /></div>
              <div><Label>Desconto</Label><Input value={form.discount} onChange={(e) => setForm(f => ({ ...f, discount: e.target.value }))} placeholder="10%" /></div>
              <div><Label>Cidade</Label><Input value={form.cidade} onChange={(e) => setForm(f => ({ ...f, cidade: e.target.value }))} /></div>
              <div><Label>Estado</Label><Input maxLength={2} value={form.estado} onChange={(e) => setForm(f => ({ ...f, estado: e.target.value.toUpperCase() }))} /></div>
            </div>
            <div><Label>Descrição</Label><Textarea rows={2} value={form.description} onChange={(e) => setForm(f => ({ ...f, description: e.target.value }))} /></div>
            <div><Label>Instruções de uso</Label><Textarea rows={2} value={form.instructions} onChange={(e) => setForm(f => ({ ...f, instructions: e.target.value }))} /></div>
            <div className="flex items-center gap-2">
              <Switch checked={form.is_active} onCheckedChange={(v) => setForm(f => ({ ...f, is_active: v }))} />
              <Label>Ativo</Label>
            </div>
            <Button type="submit" className="w-full">{editId ? "Salvar" : "Cadastrar"}</Button>
          </form>
        </DialogContent>
      </Dialog>
    </AdminLayout>
  );
}
